import { Button } from '@creditsights/styleguide-web';
import { Row } from '@tanstack/react-table';
import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import { CaseDocumentsQueryFilters } from '../../../../hooks/dockets/useFetchCaseDocuments';
import styles from './AttachmentSeeMore.module.scss';
import useSeeMoreAttachments from '../../../../hooks/dockets/useSeeMoreAttachments';
import { DocketCaseDocument } from '../../../../models/CompanyDockets';

const cx = classNames.bind(styles);

interface AttachmentSeeMoreProps {
  row?: Row<DocketCaseDocument>;
  className?: string;
  page: number;
  pageSize: number;
  filters: CaseDocumentsQueryFilters;
  keyFilings: boolean;
}

const AttachmentSeeMore = ({
  row,
  className,
  page,
  pageSize,
  filters,
  keyFilings,
}: AttachmentSeeMoreProps): ReactElement | null => {
  const { toggleSeeMore } = useSeeMoreAttachments(row?.original, page, pageSize, filters, keyFilings);

  if (!row || (row.original.subRows && row.original.subRows.length <= 5)) {
    return null;
  }

  return (
    <tr className={className}>
      <td colSpan={row.getVisibleCells().length - 2} />
      <td colSpan={2}>
        <Button className={cx('button')} onClick={toggleSeeMore}>
          {row.original.seeMore ? 'See less' : 'See more'}
        </Button>
      </td>
    </tr>
  );
};

export default AttachmentSeeMore;
